import TailwindButton from "src/components/general/tailwindButton";

export interface RedactModalProps {
  handleChange: (value: boolean) => void;
  modalTitle: string;
  modalText: string;
}

const RedactModal = ({ handleChange, modalText, modalTitle }: RedactModalProps) => {
  return (
    <div className="fixed inset-0 z-40 min-h-full overflow-y-auto overflow-x-hidden transition flex items-center">
      <div
        aria-hidden="true"
        className="fixed inset-0 w-full h-full bg-black/50 cursor-pointer"
      ></div>

      <div className="relative w-full cursor-pointer pointer-events-none transition my-auto p-4">
        <div className="w-full py-2 bg-redactThreatBlack cursor-default pointer-events-auto dark:bg-gray-800 relative rounded-xl mx-auto max-w-sm">
          <button
            tabIndex={-1}
            type="button"
            className="absolute top-2 right-2 rtl:right-auto rtl:left-2"
            onClick={() => handleChange(false)}
          >
            <svg
              tabIndex={-1}
              className="h-4 w-4 cursor-pointer text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span className="sr-only">Close</span>
          </button>

          <div className="space-y-2 p-2">
            <div className="p-4 space-y-2 text-center text-redactWhite">
              <h2 className="text-xl font-bold tracking-tight" id="page-action.heading">
                {modalTitle}
              </h2>

              <p className="text-redactWhite">{modalText}</p>
            </div>
          </div>

          <div className="space-y-2">
            <div aria-hidden="true" className="border-t border-gray-700 px-2"></div>

            <div className="px-6 py-2">
              <div className="w-full items-center justify-center flex">
                <TailwindButton
                  buttonBGColor="bg-brand-slate"
                  buttonBorderColor="border-brand-purple"
                  buttonHeight="h-10"
                  buttonText="Continue"
                  buttonURL={undefined}
                  buttonTextTailwindStyle="font-bold text-[16px] text-white"
                  buttonWidth="w-32"
                  onClick={() => handleChange(false)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedactModal;
